module.exports = __webpack_public_path__ + "media/cortina/guia-debajodecielo-0482dc72.png";